<script lang="ts">
  const browser = typeof window !== 'undefined';
  
  export let title: string;
  export let _class;
  let titleElement: HTMLElement;
  let resizeNeeded = false;

  function adjustFontSize() {
    if (!titleElement) return;
    
    // Reset style initially to measure the natural size
    titleElement.style.fontSize = '';
    
    // Wait for the next frame to ensure the element has rendered
    requestAnimationFrame(() => {
      const textWidth = titleElement.scrollWidth;
      const containerWidth = titleElement.parentElement?.clientWidth || 270;
      
      // Trigger resize 10px earlier by reducing the container width in the comparison
      const adjustedContainerWidth = containerWidth - 10;
      
      // Only resize if the text is wider than its container (with 10px buffer)
      if (textWidth > adjustedContainerWidth) {
        resizeNeeded = true;
        const scale = adjustedContainerWidth / textWidth;
        const newSize = Math.max(24 * scale, 14); // Scale down from 24px, but not below 14px
        titleElement.style.fontSize = `${newSize}px`;
      } else {
        // Make sure we don't have any inline style if no resize is needed
        resizeNeeded = false;
        titleElement.style.fontSize = '';
      }
    });
  }

  $: if (title && browser) {
    // Run on next frame to ensure the DOM is updated
    setTimeout(adjustFontSize, 0);
  }
</script>

<div class="title-container">
  <h3 class="card-title {_class} {resizeNeeded ? 'resized' : ''}" bind:this={titleElement}>
    {title}
  </h3>
</div>

<style lang="scss">
  .title-container {
    width: 100%;
    padding: 0px;
    height: 36px; // Fixed height for title area
    display: flex;
    align-items: center;
  }

  .card-title {
    font-weight: 600;
    line-height: 1.5;
    margin: 0;
    display: block;
    font-size: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .card-title.resized {
    text-overflow: ellipsis;
  }
</style>